export enum MEMBER_ID_TYPE{
  UMI = 'UMI',
  AGR = 'AGR',
  SSN = 'SSN'
}
export interface FindMemberRequestPayload {
  payload: {
    idType: MEMBER_ID_TYPE,
    memberId: string,
    agencyId: string
  };
}
